import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const EmptyStateSegment = ({ height = 128, width = 128, ...props }: SvgIconProps) => (
  <SvgIcon
    height={height}
    width={width}
    viewBox="0 0 128 128"
    data-test="segment-empty-state"
    {...props}
  >
    <path
      d="M115.84 71.808C115.839 64.1676 114.129 56.6242 110.833 49.7309C107.538 42.8377 102.742 36.7693 96.7965 31.9706C90.851 27.172 83.9069 23.7649 76.4734 21.999C69.0398 20.2332 61.3053 20.1534 53.837 21.7655C46.3686 23.3776 39.3556 26.6407 33.3124 31.3156C27.2691 35.9905 22.3488 41.9586 18.912 48.7824C15.4753 55.6063 13.6093 63.1127 13.4509 70.7515C13.2926 78.3902 14.8458 85.9676 17.9967 92.928H111.283C114.293 86.2941 115.847 79.0926 115.84 71.808Z"
      fill={colors.grey5}
    />
    <path
      d="M14.0801 92.928H113.92"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.31982 92.928H11.5198"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M116.48 92.928H119.68"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M52.1217 105.194C52.1217 106.474 46.2698 107.626 38.9974 107.626C31.725 107.626 25.8784 106.538 25.8784 105.194C25.8784 103.85 31.7304 102.762 38.9974 102.762C46.2644 102.762 52.1217 103.914 52.1217 105.194Z"
      fill={colors.grey5}
    />
    <path
      d="M103.01 99.804C103.01 101.258 94.9823 102.566 85.0062 102.566C75.0301 102.566 67.0098 101.33 67.0098 99.804C67.0098 98.2775 75.0374 97.0417 85.0062 97.0417C94.975 97.0417 103.01 98.3502 103.01 99.804Z"
      fill={colors.grey5}
    />
    <circle cx="39" cy="89" r="15.5" fill="white" stroke={colors.purple100} />
    <path d="M35 98.4999V95.4999H43V98.4999H35Z" fill={colors.purple50} stroke={colors.purple100} />
    <path fillRule="evenodd" clipRule="evenodd" d="M44.5 89V86.5V89Z" fill="white" />
    <path d="M44.5 89V86.5V84.5H33.5V89L36 91H42L44.5 89Z" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.5 89V86.5V89Z"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.5 89V86.5V84.5H33.5V89L36 91H42L44.5 89Z"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M39 100.5V96" stroke={colors.purple100} strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M38 86.9999C37.7842 86.6618 37.4 86.4697 37 86.4999C36.6 86.4697 36.2158 86.6618 36 86.9999"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42 86.9999C41.7842 86.6618 41.4 86.4697 41 86.4999C40.6 86.4697 40.2158 86.6618 40 86.9999"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39 96C48 96 44.5 89 44.5 89C43.7507 89.5139 42.897 89.8554 42 90C41 90 41 88.5 39 88.5C37 88.5 37 90 36 90C35.103 89.8554 34.2493 89.5139 33.5 89C33.5 89 30 96 39 96Z"
      fill={colors.purple10}
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.5 92C37.8727 92.3332 38.3582 92.512 38.858 92.5H39.142C39.6418 92.5122 40.1274 92.3334 40.5 92"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45 82.5H33C32.4477 82.5 32 82.9477 32 83.5C32 84.0523 32.4477 84.5 33 84.5H45C45.5523 84.5 46 84.0523 46 83.5C46 82.9477 45.5523 82.5 45 82.5Z"
      fill={colors.cyan10}
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.917 82.5C44.4314 79.6106 41.9299 77.4945 39 77.4945C36.0701 77.4945 33.5687 79.6106 33.083 82.5"
      fill={colors.purple50}
    />
    <path
      d="M44.917 82.5C44.4314 79.6106 41.9299 77.4945 39 77.4945C36.0701 77.4945 33.5687 79.6106 33.083 82.5"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39 82.5V84.5"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.5 82.5V84.5"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42.5 82.5V84.5"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39 97.5L42.842 98.781C42.9946 98.8318 43.1623 98.8061 43.2927 98.712C43.423 98.6179 43.5002 98.4668 43.5 98.306V95.277"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M34.5 95.277V98.306C34.4998 98.4668 34.577 98.6179 34.7073 98.712C34.8377 98.8061 35.0054 98.8318 35.158 98.781L39 97.5"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50.5 100.5C50.4991 98.8316 49.4628 97.3389 47.9 96.755L43.21 95.179"
      fill={colors.purple100}
    />
    <path
      d="M50.5 100.5C50.4991 98.8316 49.4628 97.3389 47.9 96.755L43.21 95.179V98.7087L39 97.4998V100.5H50.5Z"
      fill={colors.purple100}
    />
    <path
      d="M50.5 100.5C50.4991 98.8316 49.4628 97.3389 47.9 96.755L43.21 95.179V98.7087L39 97.4998V100.5H50.5Z"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.79 95.179L30.1 96.755C28.5371 97.3389 27.5008 98.8316 27.5 100.5"
      fill={colors.purple100}
    />
    <path
      d="M34.79 95.179L30.1 96.755C28.5371 97.3389 27.5008 98.8316 27.5 100.5L39 100.5V97.4998L34.79 98.6228V95.179Z"
      fill={colors.purple100}
    />
    <path
      d="M34.79 95.179L30.1 96.755C28.5371 97.3389 27.5008 98.8316 27.5 100.5L39 100.5V97.4998L34.79 98.6228V95.179Z"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M39 96.9999V101" stroke={colors.purple50} />
    <circle cx="85" cy="75" r="23.5" fill="white" stroke={colors.purple100} />
    <path
      d="M102.25 92.25H67.7499C67.6663 89.8441 68.1125 88.1238 69.5224 86.754C70.9843 85.3337 73.4823 84.2902 77.4999 83.25C83.1804 85.8357 86.4821 85.7107 92.4999 83.25C100.235 85.2169 102.582 87.0993 102.25 92.25Z"
      fill={colors.purple10}
      stroke={colors.purple100}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M100.75 83.6999V69.2999C100.75 66.1188 98.064 63.5399 94.7503 63.5399C94.7503 63.5399 79.7503 63.7501 74.5003 63.7501"
      fill={colors.purple50}
    />
    <path
      d="M100.75 83.6999V69.2999C100.75 66.1188 98.064 63.5399 94.7503 63.5399C94.7503 63.5399 79.7503 63.7501 74.5003 63.7501C69.2503 63.7501 69.2507 67.5001 69.2503 69.2999C69.2499 71.0997 69.2503 83.6999 69.2503 83.6999H100.75Z"
      fill={colors.purple50}
    />
    <path
      d="M100.75 83.6999V69.2999C100.75 66.1188 98.064 63.5399 94.7503 63.5399C94.7503 63.5399 79.7503 63.7501 74.5003 63.7501C69.2503 63.7501 69.2507 67.5001 69.2503 69.2999C69.2499 71.0997 69.2503 83.6999 69.2503 83.6999H100.75Z"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M72.25 73.62C72.25 80.7782 77.5435 85.14 85 85.14C92.4565 85.14 97.75 80.7782 97.75 73.62V72.18C97.75 65.0217 92.4565 59.22 85 59.22C77.5435 59.22 72.25 65.0217 72.25 72.18V73.62Z"
      fill={colors.purple10}
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M94.75 72.8999C94.75 78.0695 90.385 79.3799 85 79.3799C79.615 79.3799 75.25 78.0695 75.25 72.8999C75.25 67.7305 79.6152 63.5399 85 63.5399C90.3848 63.5399 94.75 67.7305 94.75 72.8999Z"
      fill={colors.cyan10}
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M79.27 71.1892C79.8541 69.397 81.3083 67.9886 83.17 67.4121"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M102.25 92.3399V90.8999C102.249 88.4974 100.694 86.348 98.35 85.5071L92.1025 83.4911"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M77.8915 83.494L71.65 85.5071C69.3057 86.348 67.7513 88.4974 67.75 90.8999V92.3399"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M79 92.34C78.5858 92.34 78.25 92.0177 78.25 91.62V89.46C78.25 88.6647 78.9216 88.02 79.75 88.02H90.25C91.0784 88.02 91.75 88.6647 91.75 89.46V91.62C91.75 92.0177 91.4142 92.34 91 92.34H79Z"
      fill={colors.purple50}
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M85.75 88.02V92.34"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M94.75 90.9H97.75"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M72.25 92.34H75.25"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M73.75 89.4601H75.25"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="48" cy="46" r="15.5" fill="white" stroke={colors.purple100} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.9996 51.4998C49.3866 51.4998 52.4896 49.7788 52.9316 47.1348C52.9863 46.8064 53.2007 46.5268 53.5036 46.3888C54.5816 45.8988 54.8516 43.9368 53.9806 43.4998C54.4806 40.5138 54.4806 35.4998 47.9996 35.4998C46.746 35.4513 45.5 35.7152 44.3736 36.2678C41.5496 37.7878 41.6416 41.2298 42.0186 43.4998C41.1476 43.9368 41.4186 45.8998 42.4956 46.3888C42.7986 46.5268 43.013 46.8064 43.0676 47.1348C43.5096 49.7788 46.6126 51.4998 47.9996 51.4998Z"
      fill="white"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M46.5 48C46.8727 48.3332 47.3582 48.512 47.858 48.5H48.142C48.6418 48.5122 49.1274 48.3334 49.5 48"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M47 43.9999C46.7842 43.6618 46.4 43.4697 46 43.4999C45.6 43.4697 45.2158 43.6618 45 43.9999"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51 43.9999C50.7842 43.6618 50.4 43.4697 50 43.4999C49.6 43.4697 49.2158 43.6618 49 43.9999"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.8281 41.4849C43.1591 41.4489 45.8711 41.8759 48.0001 39.3149C50.1171 41.8619 52.8431 41.4639 54.1721 41.4929"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.2632 36.33C43.6772 34.9465 42.1583 34.2099 40.7091 34.6063C39.26 35.0027 38.3275 36.41 38.5274 37.8991C38.7272 39.3881 39.9978 40.4997 41.5002 40.5C41.6222 40.4999 41.7441 40.4922 41.8652 40.477"
      fill={colors.purple10}
    />
    <path
      d="M44.2632 36.33C43.6772 34.9465 42.1583 34.2099 40.7091 34.6063C39.26 35.0027 38.3275 36.41 38.5274 37.8991C38.7272 39.3881 39.9978 40.4997 41.5002 40.5C41.6222 40.4999 41.7441 40.4922 41.8652 40.477"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M51.7368 36.33C52.3228 34.9465 53.8417 34.2099 55.2909 34.6063C56.74 35.0027 57.6725 36.41 57.4726 37.8991C57.2727 39.3881 56.0022 40.4997 54.4998 40.5C54.3778 40.4999 54.2559 40.4922 54.1348 40.477"
      fill={colors.purple10}
    />
    <path
      d="M51.7368 36.33C52.3228 34.9465 53.8417 34.2099 55.2909 34.6063C56.74 35.0027 57.6725 36.41 57.4726 37.8991C57.2727 39.3881 56.0022 40.4997 54.4998 40.5C54.3778 40.4999 54.2559 40.4922 54.1348 40.477"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M59.5 57.5C59.4992 55.8315 58.4629 54.3389 56.9 53.755L51.87 52.066C51.6579 51.9947 51.4242 52.0732 51.298 52.258C50.5523 53.3466 49.3176 53.9974 47.998 53.9974C46.6784 53.9974 45.4437 53.3466 44.698 52.258C44.5715 52.0735 44.3379 51.9955 44.126 52.067L39.1 53.755C37.5371 54.3389 36.5008 55.8315 36.5 57.5"
      fill={colors.purple50}
    />
    <path
      d="M59.5 57.5C59.4992 55.8315 58.4629 54.3389 56.9 53.755L51.87 52.066C51.6579 51.9947 51.4242 52.0732 51.298 52.258C50.5523 53.3466 49.3176 53.9974 47.998 53.9974C46.6784 53.9974 45.4437 53.3466 44.698 52.258C44.5715 52.0735 44.3379 51.9955 44.126 52.067L39.1 53.755C37.5371 54.3389 36.5008 55.8315 36.5 57.5H59.5Z"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48.0001 35.5C41.5002 35.5 42.0001 41.5 42.0001 41.5C42.0001 41.5 44.3159 41.4919 45.5 41C46.6719 40.5131 47.1661 39.5 48 39.5C48.8339 39.5 49.3725 40.5316 50.5 41C51.6841 41.4919 54 41.5 54 41.5C54 41.5 54.5 35.5 48.0001 35.5Z"
      fill={colors.purple10}
      stroke={colors.purple100}
    />
    <path
      d="M48.409 56.5601C50.7376 56.5601 52.8517 55.2006 53.818 53.082L51.9092 53C51.9092 53 49.9092 54.5 48.4092 54.5C46.9092 54.5 44.9092 53 44.9092 53L43 53.082C43.9663 55.2006 46.0804 56.5601 48.409 56.5601Z"
      fill={colors.cyan10}
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
